module.exports = __webpack_public_path__ + "media/images/home-page/3-6-014073e26cacaa29e810f91101d3b746.png";